export default "__VITE_ASSET__BzGfFdsB__"